import notificationStreamIconModule from "../notificationStreamIconModule";

function notificationStreamIndicator(notificationStreamUtility, $document, $log, notificationStreamService) {
    "ngInject";

    return {
        restrict: "A",
        replace: true,
        scope: true,
        templateUrl: notificationStreamUtility.templates.notificationStreamIndicatorTemplate,
        link: function (scope, element, attrs) {
            scope.layout = scope.layout || {};
            scope.getUnreadNotificationCount = function () {
                notificationStreamService.unreadCount()
                    .then(
                        function (data) {
                            if (data) {
                                const { unreadNotifications } = data;
                                scope.layout.unreadNotifications = unreadNotifications;
                            }
                        },
                        function () {
                            $log.debug("--- unreadCount call failed from notificationStreamIndicatorDirective----- ");
                        }
                    );
            }
            function updateLayout(data) {
                scope.layout.unreadNotifications = data.count;
                scope.layout.isNotificationContentOpen = data.isNotificationContentOpen;
            }
            $document.bind("Roblox.NotificationStream.UnreadNotifications",
                function (event, args) {
                    $log.debug(" ----- notificationStreamIconController --- args.count --------" + args.count);
                    scope.$evalAsync(updateLayout(args));
                });

            if (!scope.layout || !scope.layout.isNotificationContentOpen) {
                scope.getUnreadNotificationCount();
            }

        }
    }
}

notificationStreamIconModule.directive("notificationStreamIndicator", notificationStreamIndicator);

export default notificationStreamIndicator;